import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';

import { RecordArrangePage } from '~/features/insights/edit/arrange-record';

/** Arrange insights for a record: the one place its layout changes. */
function ArrangeRoute(): ReactElement {
  const { recordId } = Route.useParams();
  return <RecordArrangePage key={recordId} recordId={recordId} />;
}

export const Route = createFileRoute('/_app/records/$recordId/insights/arrange')({ component: ArrangeRoute });
